import "./App.css";
import CDV from "./components/CDV";
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";

function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/main" element={<CDV />} />
          <Route path="/" element={<Navigate to="/main" replace="false" relative="false" />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
